export default __webpack_public_path__ + "static/media/tiktok.374c81e9.jpeg";